// extracted by mini-css-extract-plugin
module.exports = {"failedIcon":"ResultSet_failedIcon__3ALO2","successIcon":"ResultSet_successIcon__q1GDW","result":"ResultSet_result__2AK3b","actualOutput":"ResultSet_actualOutput__3BbIe"};